export default {
  rightsReserved: {
    en: "All Rights Reserved.",
    ita: "Tutti i diritti riservati.",
    de: "Alle Rechte vorbehalten."
  }
};
